import React, { useState, useEffect, CSSProperties } from 'react';
import './tableRender.css';


const TableRender: React.FC<TableProps> = ({
  rows,
  schema,
  id,
  showCheckboxes,
  actions,
  loading,
  tableClass,
  striped,
  sortByFn,
  slots = {},
  simpleSort,
  stikyToTop = true
}) => {
  const [checkboxChecked] = useState(false);
  // const [mySelectedRows, setMySelectedRows] = useState<any[]>([]);
  const [mySchema, setMySchema] = useState<TableColumn[]>([]);
  const [myRows, setMyRows] = useState<any[]>([]);
  const [sortColumnKey, setSortColumnKey] = useState<string | null>(null);
  const [sortDirection, setSortDirection] = useState<string | null>(null);
  const [sortCustomEle, setSortCustomEle] = useState({
    icon: 'up',
    active: null as string | null,
    type: null as string | null,
  });

  useEffect(() => {
    setMyRows(rows);
    setMySchema(schema);
  }, [rows, schema]);

  const sortColumn = (key: string): void => {
    if (sortColumnKey === key) {
      setSortDirection((prevDirection) => (prevDirection === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortColumnKey(key);
      setSortDirection('asc');
    }

    const sortedRows = myRows.slice().sort((a, b) => {
      const valueA = a[key];
      const valueB = b[key];
      return compareValues(valueA, valueB) * (sortDirection === 'asc' ? 1 : -1);
    });

    setMyRows(sortedRows);
  };

  const compareValues = (valueA: any, valueB: any): number => {
    if (typeof valueA === 'number' && typeof valueB === 'number') {
      return valueA - valueB;
    } else if (typeof valueA === 'string' && typeof valueB === 'string') {
      return valueA.localeCompare(valueB);
    } else {
      return 0;
    }
  };

  const sortByCustom = (sortAs: string, element: string): void => {
    if (!sortCustomEle.active || sortCustomEle.active !== element) {
      setSortCustomEle({
        icon: 'up',
        active: element,
        type: 'asc',
      });
    } else if (sortCustomEle.active === element) {
      if (sortCustomEle.icon === 'down') {
        setSortCustomEle({
          icon: 'up',
          active: null,
          type: null,
        });
      } else {
        setSortCustomEle({
          ...sortCustomEle,
          icon: 'down',
          type: 'desc',
        });
      }
    }
    if (typeof sortByFn === 'function') {
      sortByFn(sortCustomEle);
    }
  };

  const selectAll = (event: React.ChangeEvent<HTMLInputElement>): void => {
    // Logic for selecting all rows
    // setMySelectedRows([...]);
  };

  const setRowMarked = (id: string): void => {
    // Logic for marking a specific row
    // setMySelectedRows([...]);
  };

  return (
    <div id={id} className={`overflow-x-auto w-100 table-responsive ${tableClass || ''}`}>
      <table className={`table table-container table-hover table-bordered ${striped ? 'table-striped' : ''}`} data-click-to-select="true" data-show-columns-toggle-all="true">
        <thead className={`${stikyToTop ? 'sticky-top bg-white' : ''}`}>
          <tr>
            {showCheckboxes && (
              <th className="">
                <input type="checkbox" checked={checkboxChecked} onChange={selectAll} />
              </th>
            )}
            {mySchema.map((column, i) => (
              <th key={column.key + '_' + i} style={ column.style as CSSProperties } className={column.class}>
                {column.customSort ? (
                  <span className="header-icon-sort" onClick={() => sortByCustom(column.customSort!, column.label)}>
                    <i
                      className={`bi cursor-pointer ${
                        sortCustomEle.active === null ? 'active-sort' : ''
                      } ${sortCustomEle.active === column.label && sortCustomEle.type === 'asc' ? 'bi-sort-up' : 'bi-sort-up-alt'}`}
                    ></i>{' '}
                    {column.label}
                  </span>
                ) : (
                  <span onClick={simpleSort ? () => sortColumn(column.key) : undefined}>
                    <span>{column.label || ''}</span>
                    {simpleSort && (
                      <i
                        className={`bi bi-sort ${sortColumnKey === column.key && sortDirection === 'asc' ? 'bi-arrow-up' : 'bi-arrow-down'}`}
                      ></i>
                    )}
                  </span>
                )}
              </th>
            ))}
            {actions && <th className="text-center">Acciones</th>}
          </tr>
        </thead>
        <tbody className={loading ? 'loading-data-table' : ''}>
          {myRows?.length > 0 ? (
            myRows.map((row, i) => (
              <tr key={row.id + '_' + i} onClick={showCheckboxes ? () => setRowMarked(row.id) : undefined}>
                {showCheckboxes && (
                  <td>
                    <input type="checkbox" id={row.id} name={row.id} value={row.id} disabled={row.disabled_checkbox} />
                  </td>
                )}
                {mySchema.map((col, i) => (
                  <td key={col.key + '_' + i} className={mySchema.find(head => head.key === col.key && head.classBody)?.classBody || ''}>
                    {slots[col.slotName!] ? (
                      <>{slots[col.slotName!](row)}</>
                    ) : (
                      <span id={`${col.key}_${row.id}`} data-currentvalue={row[col.key]} className={!row[col.key] ? 'empty-data' : ''}>
                        {row[col.key] || '--'}
                      </span>
                    )}
                  </td>
                ))}
                {actions && (
                  <th className="text-center">
                    <div>
                      <a href="javascript:" className="actions-points" data-bs-toggle="dropdown">
                        <i className="bi bi-three-dots-vertical cursor-pointer"></i>
                      </a>
                      <div className="dropdown-menu">
                        {actions.map((act, i) => (
                          <button key={`action_btn${row.id + i}`} className="dropdown-item" onClick={() => act.action(row.id)}>
                            <i
                              className={`bi cursor-pointer ${act.icon} ${act.color ? `text-${act.color}` : 'text-black'}`}
                            ></i>{' '}
                            {act.text}
                          </button>
                        ))}
                      </div>
                    </div>
                  </th>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td className="text-center py-5" colSpan={showCheckboxes ? mySchema.length + 1 : mySchema.length + (actions ? 1 : 0)}>
                No se encontraron registros para mostrar
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableRender;


interface TableColumn {
  key: string;
  label: string;
  customSort?: string;
  slotName?: string;
  style?: any;
  class?: string;
  classBody?: string;
}

interface TableAction {
  icon: string;
  text: string;
  color?: string;
  action: (id: string) => void;
  showOnly?: { key: string; value: any };
}

interface TableProps {
  rows: any[];
  schema: TableColumn[];
  id: string;
  showCheckboxes?: boolean;
  actions?: TableAction[];
  loading?: boolean;
  tableClass?: string;
  striped?: boolean;
  sortByFn?: (selection: { icon: string; active: string | null; type: string | null }) => void;
  slots?: Record<string, (row: any) => React.ReactNode>;
  simpleSort?: boolean;
  stikyToTop?: boolean;
}